(() => {
  const root = document.querySelector('[data-sq-product]');
  if (!root) return;
  const form = root.querySelector('[data-sq-form]');
  let pending = false;
  if (form) form.addEventListener('submit', async event => {
    event.preventDefault();
    const variant = form.querySelector('input[name="id"]');
    if (pending || root.dataset.ready !== 'true' || !variant?.value) return;
    const button = form.querySelector('[data-add]');
    const error = form.querySelector('[data-sq-error]');
    const originalLabel = button.innerHTML;
    pending = true;
    button.disabled = true;
    button.textContent = form.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    error.hidden = true;
    try {
      const endpoint = new URL(form.action, location.origin);
      endpoint.pathname = endpoint.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(endpoint, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok) {
        error.textContent = typeof result.description === 'string' ? result.description : form.dataset.error;
        error.hidden = false;
      } else {
        location.assign(form.dataset.cartUrl);
        return;
      }
    } catch {
      error.textContent = form.dataset.networkError;
      error.hidden = false;
    }
    pending = false;
    button.disabled = false;
    button.innerHTML = originalLabel;
    form.removeAttribute('aria-busy');
  });
  const main = root.querySelector('[data-sq-gallery-main] img');
  const imageError = root.querySelector('[data-gallery-error]');
  if (main && imageError) {
    const gallery = root.querySelector('[data-sq-gallery-main]');
    main.addEventListener('error', () => {
      main.hidden = true;
      if (gallery && !gallery.querySelector('[data-sq-photo-fallback]')) {
        const fallback = document.createElement('div');
        fallback.setAttribute('data-sq-photo-fallback', '');
        fallback.setAttribute('role', 'img');
        fallback.setAttribute('aria-label', 'Butter Squishy product image unavailable');
        fallback.textContent = 'Butter Squishy';
        gallery.appendChild(fallback);
      }
      imageError.hidden = false;
    });
    main.addEventListener('load', () => {
      main.hidden = false;
      gallery?.querySelector('[data-sq-photo-fallback]')?.remove();
      imageError.hidden = true;
    });
  }
  // Load a selected photo before replacing the visible photo so a bad
  // supplier image cannot leave the main gallery in a broken state.
  let photoRequest = 0;
  const photos = [...root.querySelectorAll('[data-sq-photo]')];
  photos.forEach(button => button.addEventListener('click', () => {
    if (!main || !button.dataset.sqPhoto) return;
    const request = ++photoRequest;
    const candidate = new Image();
    candidate.onload = () => {
      if (request !== photoRequest) return;
      main.removeAttribute('srcset');
      main.src = button.dataset.sqPhoto;
      main.alt = button.dataset.sqAlt || '';
      if (imageError) imageError.hidden = true;
      photos.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    };
    candidate.onerror = () => {
      if (request !== photoRequest) return;
      if (imageError) imageError.hidden = false;
    };
    candidate.src = button.dataset.sqPhoto;
  }));
})();
